import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=364d61e9&scoped=true"
import script from "./option-group.vue?vue&type=script&lang=js"
export * from "./option-group.vue?vue&type=script&lang=js"
import style0 from "./option-group.vue?vue&type=style&index=0&id=364d61e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d61e9",
  null
  
)

export default component.exports